module.exports = __webpack_public_path__ + "static/media/404-background.a14791fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/404-background.png
// module id = 1899
// module chunks = 0